import { createContext } from "react";

import { ModalState } from "./types";

export const ModalContext = createContext<ModalState>({
  Component: null,
  show: () => {
    throw new Error("No ModalContext Provider was detected");
  },
  dismiss: () => {
    throw new Error("No ModalContext Provider was detected");
  },
});
